export function sellerAdvisoryResidentialKWSW() {
return [   // Release 2026-01-09 09:39:03
 
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 180.255,
   left: 183.927,
   width: 372.753,
   height: 14.977
}
,
{
   page: 0,
   name: "Seller Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 206.6,
   left: 183.927,
   width: 372.753,
   height: 14.978
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 152.273,
   left: 183.927,
   width: 372.753,
   height: 14.978
}
,
{
   page: 5,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 579.964,
   left: 69.4183,
   width: 171.1197,
   height: 14.868
}
,
{
   page: 5,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 579.964,
   left: 243.651,
   width: 62.956,
   height: 14.868
}
] }
